import { CATEGORIA_STYLES } from "../lib/api";

const LABELS = {
  BEBES: "Bebés",
  BENJAMINES: "Benjamines",
  INFANTILES: "Infantiles",
  JUVENILES: "Juveniles",
  ADULTOS: "Adultos",
};

export default function CategoriaBadge({ categoria, className = "" }) {
  return (
    <span
      data-testid={`badge-${categoria?.toLowerCase()}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold tracking-wide ${CATEGORIA_STYLES[categoria] || ""} ${className}`}
    >
      {LABELS[categoria] || categoria}
    </span>
  );
}
